import { NgModule } from '@angular/core';
import { EmptyComponent } from './empty.component';

@NgModule({
  declarations: [EmptyComponent],
  imports: [],
  exports: [EmptyComponent],
})
export class EmptyModule {}
